import {
    deleteRouteLoading,
    deleteRouteRequest,
    deleteRouteSuccess,
    deleteRouteReject,
    deleteRouteReset
} from "../../actions/route/delete";

export const deleteRoute = (formData) => async (dispatch, getState) => {
    dispatch(deleteRouteLoading());
    try {
        const { data } = await deleteRouteRequest(formData, getState);
        dispatch(deleteRouteSuccess(data))
    } catch (error) {
        dispatch(deleteRouteReject(error))
    } finally {
        setTimeout(() => { dispatch(deleteRouteReset()) }, 3000);
    }
    return Promise.resolve();
};